import { render, staticRenderFns } from "./addDynamicData.vue?vue&type=template&id=83a4c9fe"
import script from "./addDynamicData.vue?vue&type=script&lang=js"
export * from "./addDynamicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports